export const FloorSpaceMin = 0;
export const FloorSpaceMax = 100000;
export const FloorSpaceUnit = "㎡";
export const FloorSpaceStep = 10;

interface IFloorSpaceShortcut {
  label: string;
  max?: number;
  min?: number;
}
export const FloorSpaceShortcuts: IFloorSpaceShortcut[] = [
  { max: 100, label: "100㎡以下" },
  { min: 100, max: 300, label: "100~300㎡" },
  { min: 300, max: 500, label: "300~500㎡" },
  { min: 500, max: 1000, label: "500~1,000㎡" },
  { min: 1000, label: "1,000㎡以上" },
];
